export const OVERLAP_TOUR_STORAGE_KEY = 'cityExplorer:overlapMapTour:v1';

export const isOverlapCategoryId = (id) => String(id || '').toLowerCase().includes('overlap');

export const locationHasOverlapMaps = (categories = []) =>
  categories.some((category) => isOverlapCategoryId(category?.id));

export const isOverlapMapItem = (item) =>
  item?.type === 'map' && isOverlapCategoryId(item.category?.id);

const WALK_PATTERN = /(\d+)\s*-?\s*minute\s+walk/i;

export const overlapWalkLabel = (category) => {
  const text = `${category?.description || ''} ${category?.label || ''}`;
  const match = text.match(WALK_PATTERN);
  if (match) return `${match[1]}-minute walk`;
  return '15-minute walk';
};

export const overlapTourSteps = (category) => {
  const walk = overlapWalkLabel(category);

  return [
    {
      id: 'overlap-scale',
      title: 'Catchment overlap',
      body: `This is a saturation map, not a gap map. Each charter school’s ${walk} catchment is stacked. Green means few overlapping schools; red means many. The legend below the map shows the count.`,
      spotlight: 'legend-box',
    },
    {
      id: 'high-overlap',
      title: 'Where catchments pile up',
      body: 'Warmer colors mean more charter walk zones overlap that neighborhood — more nearby options, and more competition for the same students. The highlighted area is one of those stacked catchments.',
      spotlight: 'map-covered',
      spotlightLabel: 'High overlap',
    },
    {
      id: 'thin-overlap',
      title: 'Where catchments are thin',
      body: 'Cooler greens mean fewer overlapping catchments. Those neighborhoods still have some charter walk coverage, but fewer overlapping schools than the redder core.',
      spotlight: 'map-desert',
      spotlightLabel: 'Thin overlap',
    },
    {
      id: 'search',
      title: 'Search the map',
      body: 'Use the search bars at the top to jump to an address or find a charter school by name. District schools can be toggled from the legend.',
      spotlight: 'map-search',
      spotlightLabel: 'Search',
    },
    {
      id: 'school-popups',
      title: 'School details',
      body: 'Click a school marker to open a pop-up with name, enrollment, and grades. The highlighted card is an example of what you will see.',
      spotlight: 'example-popup',
    },
  ];
};

export const readOverlapTourDismissed = () => {
  try {
    return window.localStorage.getItem(OVERLAP_TOUR_STORAGE_KEY) === '1';
  } catch (_err) {
    return false;
  }
};

export const writeOverlapTourDismissed = () => {
  try {
    window.localStorage.setItem(OVERLAP_TOUR_STORAGE_KEY, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the map.
  }
};

export const shouldShowOverlapTour = ({
  hasOverlapCategory,
  viewingOverlapMap,
  mapLoaded,
  isFullscreen,
  dismissed,
  replaying,
}) =>
  Boolean(
    hasOverlapCategory && viewingOverlapMap && mapLoaded && !isFullscreen && (!dismissed || replaying)
  );
